import React, { ReactNode } from 'react'
import cx from 'classnames'

import { useThemeContext } from '../../useThemeContext'

import cm from './Message.module.css'

export interface OutgoingMessageProps {
  variant: 'outgoing'
  children: ReactNode
  isPlaceholder?: boolean
  hasLike?: boolean
  id?: string
}

export const OutgoingMessage = React.forwardRef<
  HTMLDivElement,
  Omit<OutgoingMessageProps, 'variant'>
>((props, ref) => {
  const theme = useThemeContext()

  return (
    <div
      ref={ref}
      className={cx('p-relative', cm.message, cm.outgoing, cm[theme], {
        [cm.placeholder]: props.isPlaceholder,
        ['m-b-sm']: props.hasLike,
      })}
      data-test-id="outgoing-message"
      id={props.id}
    >
      <div>{props.children}</div>
      {props.hasLike && <div className={cm.messageLike}>❤️</div>}
    </div>
  )
})
